"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AvatarSizes = void 0;

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var styles = tslib_1.__importStar(require("./Avatar.style"));

var img_placeholder_avatar_svg_1 = tslib_1.__importDefault(require("../../assets/img-placeholder-avatar.svg"));

exports.AvatarSizes = ['xs', 'sm', 'md'];

function Avatar(_ref) {
  var className = _ref.className,
      _ref$src = _ref.src,
      src = _ref$src === void 0 ? img_placeholder_avatar_svg_1.default : _ref$src,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size;
  return jsx_runtime_1.jsx("img", {
    css: [styles.wrapper, styles.size(size)],
    className: className,
    src: src,
    alt: "avatar"
  }, void 0);
}

exports.default = Avatar;